<form [formGroup]="fileForm" fxLayout="row">
  <input #fileInput (change)="onSelectFile($event)" accept="image/png, image/jpeg" style="display: none" type="file">
  <mat-form-field appearance="none" fxFlex="70" style="width: 50%;" *ngIf="!showSubmit">
    <input [value]="filename" formControlName="filename" matInput placeholder="Fichier" readonly>
  </mat-form-field>
  <button (click)="fileInput.click()" [fxFlex]="file && showSubmit ? 15 : 100" mat-flat-button color="accent">Télécharger</button>
</form>
